import type { PayloadAction } from "@reduxjs/toolkit"
import { createSlice } from "@reduxjs/toolkit"

import type { CurrentUser } from "@/api/types"
import { logoutAction } from "@/store/session/logoutAction"
import type { RootState } from "@/store/store"

interface CurrentUserState {
  user: CurrentUser | null
}

const initialState: CurrentUserState = {
  user: null,
}

const currentUserSlice = createSlice({
  name: "currentUser",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<CurrentUser | null>) => {
      state.user = action.payload
    },
    updateUser: (state, action: PayloadAction<Partial<CurrentUser>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutAction, (state) => {
      state.user = null
    })
  },
})

export const { setUser, updateUser } = currentUserSlice.actions

export const selectCurrentUser = (state: RootState) => state.currentUser.user

export default currentUserSlice.reducer
